export default function Spinner(): JSX.Element {
  return <div className='spinner' id='spinner'></div>
}
